export const EMPLACEMENT = {
  lecture: { module: 'gabed', element: 'emplacement', rule: 'lecture' },
  maj: { module: 'gabed', element: 'emplacement', rule: 'maj' },
  exporter: { module: 'gabed', element: 'emplacement', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'emplacement', rule: 'supprimer' },
  editer: { module: 'gabed', element: 'emplacement', rule: 'edition' },
};

export const DISPOSITIF_SUPPORT = {
  lecture: { module: 'gabed', element: 'dispositif_support', rule: 'lecture' },
  maj: { module: 'gabed', element: 'dispositif_support', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'dispositif_support', rule: 'supprimer' },
};

export const DISPOSITIF_TYPE = {
  lecture: { module: 'gabed', element: 'dispositif_type', rule: 'lecture' },
  maj: { module: 'gabed', element: 'dispositif_type', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'dispositif_type', rule: 'supprimer' },
};

export const MATERIEL_LOCALISATION = {
  lecture: { module: 'gabed', element: 'materiel_localisation', rule: 'lecture' },
  maj: { module: 'gabed', element: 'materiel_localisation', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'materiel_localisation', rule: 'supprimer' },
};

export const MATERIEL_FORMAT = {
  lecture: { module: 'gabed', element: 'materiel_format', rule: 'lecture' },
  maj: { module: 'gabed', element: 'materiel_format', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'materiel_format', rule: 'supprimer' },
};

export const MATERIEL_ANGLE_VISON = {
  lecture: { module: 'gabed', element: 'materiel_angle_vision', rule: 'lecture' },
  maj: { module: 'gabed', element: 'materiel_angle_vision', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'materiel_angle_vision', rule: 'supprimer' },
};

export const MATERIEL_TYPE = {
  lecture: { module: 'gabed', element: 'materiel_type', rule: 'lecture' },
  maj: { module: 'gabed', element: 'materiel_type', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'materiel_type', rule: 'supprimer' },
};

export const FACE_CATEGORIE_TAXE = {
  lecture: { module: 'gabed', element: 'face_categorie_taxe', rule: 'lecture' },
  maj: { module: 'gabed', element: 'face_categorie_taxe', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'face_categorie_taxe', rule: 'supprimer' },
};

export const TYPE_TAXATION_TLPE = {
  lecture: { module: 'gabed', element: 'type_taxation_tlpe', rule: 'lecture' },
  maj: { module: 'gabed', element: 'type_taxation_tlpe', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'type_taxation_tlpe', rule: 'supprimer' },
  exporter: { module: 'gabed', element: 'type_taxation_tlpe', rule: 'exporter' },
};

export const ACCESSOIRE = {
  lecture: { module: 'gabed', element: 'accessoire', rule: 'lecture' },
  maj: { module: 'gabed', element: 'accessoire', rule: 'maj' },
  supprimer: { module: 'gabed', element: 'accessoire', rule: 'supprimer' },
};

export const COLLECTIVITE = {
  lecture: { module: 'gabed', element: 'collectivite', rule: 'lecture' },
  maj: { module: 'gabed', element: 'collectivite', rule: 'maj' },
  exporter: { module: 'gabed', element: 'collectivite', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'collectivite', rule: 'supprimer' },
};

export const CONFRERE = {
  lecture: { module: 'gabed', element: 'confrere', rule: 'lecture' },
  maj: { module: 'gabed', element: 'confrere', rule: 'maj' },
  exporter: { module: 'gabed', element: 'confrere', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'confrere', rule: 'supprimer' },
};

export const MATERIEL_TLPE = {
  lecture: { module: 'gabed', element: 'materielTlpe', rule: 'lecture' },
  maj: { module: 'gabed', element: 'materielTlpe', rule: 'maj' },
  exporter: { module: 'gabed', element: 'materielTlpe', rule: 'exporter' },
  editer: { module: 'gabed', element: 'materielTlpe', rule: 'edition' },
};

export const DECLARATION_TLPE = {
  lecture: { module: 'gabed', element: 'declarationTlpe', rule: 'lecture' },
  maj: { module: 'gabed', element: 'declarationTlpe', rule: 'maj' },
};

export const COMMANDE_TLPE = {
  lecture: { module: 'gabed', element: 'commande_tlpe', rule: 'lecture' },
  maj: { module: 'gabed', element: 'commande_tlpe', rule: 'maj' },
  exporter: { module: 'gabed', element: 'commande_tlpe', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'commande_tlpe', rule: 'supprimer' },
  editer: { module: 'gabed', element: 'commande_tlpe', rule: 'edition' },
};

export const FOURNISSEUR_MATERIEL = {
  lecture: { module: 'gabed', element: 'fournisseur_materiel', rule: 'lecture' },
  maj: { module: 'gabed', element: 'fournisseur_materiel', rule: 'maj' },
  exporter: { module: 'gabed', element: 'fournisseur_materiel', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'fournisseur_materiel', rule: 'supprimer' },
};

export const AFFIXE_MOBILE_PATRIMOINE = {
  lecture: { module: 'gabed', element: 'affixe_mobile_patrimoine', rule: 'lecture' },
  maj: { module: 'gabed', element: 'affixe_mobile_patrimoine', rule: 'maj' },
  exporter: { module: 'gabed', element: 'affixe_mobile_patrimoine', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'affixe_mobile_patrimoine', rule: 'supprimer' },
};

export const TITRE_RECETTE = {
  lecture: { module: 'gabed', element: 'titre_recette', rule: 'lecture' },
  maj: { module: 'gabed', element: 'titre_recette', rule: 'maj' },
  exporter: { module: 'gabed', element: 'titre_recette', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'titre_recette', rule: 'supprimer' },
};

export const PAIEMENT_RECETTE = {
  lecture: { module: 'gabed', element: 'paiement_recette', rule: 'lecture' },
  maj: { module: 'gabed', element: 'paiement_recette', rule: 'maj' },
  exporter: { module: 'gabed', element: 'paiement_recette', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'paiement_recette', rule: 'supprimer' },
};

export const LOT_PAIEMENT_RECETTE = {
  lecture: { module: 'gabed', element: 'lot_paiement_recette', rule: 'lecture' },
  maj: { module: 'gabed', element: 'lot_paiement_recette', rule: 'maj' },
  exporter: { module: 'gabed', element: 'lot_paiement_recette', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'lot_paiement_recette', rule: 'supprimer' },
};

export const JOURNAL_PAIEMENT_RECETTE = {
  lecture: { module: 'gabed', element: 'journal_paiement_recette', rule: 'lecture' },
  maj: { module: 'gabed', element: 'journal_paiement_recette', rule: 'maj' },
  exporter: { module: 'gabed', element: 'journal_paiement_recette', rule: 'exporter' },
  supprimer: { module: 'gabed', element: 'journal_paiement_recette', rule: 'supprimer' },
};
